import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, TypographyConfig } from '@vds-core/typography';
import { colors } from '@vds-core/theme';
var propTypes = {
  /**
   * The Cell allows Any types as children.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   */
  cellPadding: PropTypes.string,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  viewport: PropTypes.oneOf(['mobile', 'tablet', 'desktop']),

  /**
   * @ignore
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  bodyConfig: BodyConfig,
  cellPadding: calculateRem(12, 32, 24, 0),
  children: undefined,
  className: undefined,
  typescale: TypographyConfig.getTypescale(),
  viewport: 'desktop',
  colorConfig: colors
};
var StyledCell = /*#__PURE__*/styled.td.withConfig({
  displayName: "StyledCell",
  componentId: "sc-35tlbe-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  padding: ", ";\n  text-align: left;\n  vertical-align: top;\n\n  &:active,\n  &:focus,\n  &:hover {\n    outline: none;\n  }\n"])), function (_ref) {
  var bodyConfig = _ref.bodyConfig,
      getFontStyles = _ref.getFontStyles,
      typescale = _ref.typescale,
      viewport = _ref.viewport;
  return getFontStyles(bodyConfig, typescale, viewport);
}, function (_ref2) {
  var colorConfig = _ref2.colorConfig;
  return colorConfig.black;
}, function (_ref3) {
  var cellPadding = _ref3.cellPadding;
  return cellPadding;
});

var Cell = function Cell(props) {
  var bodyConfig = props.bodyConfig,
      cellPadding = props.cellPadding,
      children = props.children,
      typescale = props.typescale,
      viewport = props.viewport,
      colorConfig = props.colorConfig;

  function _getFontStack(bodyConfig, typescale, TypographyConfig, viewport) {
    var BodySmallMobile = bodyConfig.getStyles(typescale, 'mobile', 'small');
    var BodyMediumDesktop = bodyConfig.getStyles(typescale, 'desktop', 'medium');
    var BodyMediumMobile = bodyConfig.getStyles(typescale, 'mobile', 'medium');
    var BodyLargeDesktop = bodyConfig.getStyles(typescale, 'desktop', 'large');
    var fontStack;
    var mobile = viewport === 'mobile';
    typescale === 'VDS' ? fontStack = mobile ? BodySmallMobile : BodyLargeDesktop : fontStack = mobile ? BodyMediumMobile : BodyMediumDesktop;
    return fontStack;
  }

  function _getFontStyles() {
    var fontStack = _getFontStack(bodyConfig, typescale, TypographyConfig, viewport);

    return "\n      font-family: ".concat(fontStack.fontFamily, ";\n      font-size: ").concat(calculateRem(fontStack.fontSize), ";\n      letter-spacing: ").concat(fontStack.letterSpacing && fontStack.letterSpacing, ";\n      line-height: ").concat(calculateRem(fontStack.lineHeight), ";\n      letter-spacing: ").concat(fontStack.letterSpacing && calculateRem(fontStack.letterSpacing), ";\n    ");
  }

  return /*#__PURE__*/React.createElement(StyledCell, _extends({
    bodyConfig: bodyConfig,
    cellPadding: cellPadding,
    getFontStyles: _getFontStyles,
    typescale: typescale,
    viewport: viewport,
    colorConfig: colorConfig
  }, props), children);
};

Cell.propTypes = propTypes;
Cell.defaultProps = defaultProps;
export default Cell;